<template>
  <q-icon :size="size" class="tick">
    <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
      <g>
        <polygon points="13.3,26.7 2.4,19 3.6,17.4 12.9,24 28.2,6 29.8,7.3 	" />
      </g>
    </svg>
  </q-icon>
</template>

<script>
export default {
  name: 'TickIcon',
  props: {
    size: {
      type: String,
      default: '14px'
    }
  }
}
</script>

<style scoped>

</style>
